import { useEffect } from 'react';

interface ClipboardHookInput {
  acceptedFiles: string[];
  onFilePasted: (file: File) => void;
}

const isFileAccepted = (fileType: string, acceptedFiles: string[]) => {
  const [type, subtype] = fileType.split('/');

  for (const acceptedFile of acceptedFiles) {
    const [acceptedType, acceptedSubtype] = acceptedFile.split('/');
    if (acceptedType === type && (acceptedSubtype === '*' || acceptedSubtype === subtype)) {
      return true;
    }
  }
  return false;
};

export default function useClipboard(input: ClipboardHookInput) {
  const { acceptedFiles, onFilePasted } = input;
  useEffect(() => {
    function handlePaste(event: any) {
      const clipboardEvent = event as ClipboardEvent;
      if (!clipboardEvent) return;

      const [item] = clipboardEvent.clipboardData?.items || [];

      if (!item || !isFileAccepted(item.type, acceptedFiles)) return;

      const file = item.getAsFile();
      if (file) {
        onFilePasted(file);
      }
    }

    window.addEventListener('paste', handlePaste);
    return () => {
      window.removeEventListener('paste', handlePaste);
    };
  }, [acceptedFiles, onFilePasted]);
}
